import React from 'react';

import DonutFiguresCard from '~support-at-home/components/common/DonutFiguresCard';
import SectionInfo from '~support-at-home/components/common/SectionInfo';

import { DASHBOARD_TEXT } from './dashboardText';
import { DashboardWidgetStatus, READY_WIDGET } from './dashboardWidgets';
import { DashboardWidgetState } from './DashboardWidgetState';
import { OverviewView } from './utils';

interface ComponentProps {
  /** Null until the figures it needs have arrived. */
  view: OverviewView | null;
  /** Loading or failed: the state box replaces the ring and figures, under the title. Default ready. */
  status?: DashboardWidgetStatus;
}

const copy = DASHBOARD_TEXT.careManagement;

/**
 * Care Management Overview (TAV-3345, restyled TAV-3442, TAV-3463): the Budget Tracker's Care Management Overview over
 * the included budgets that can have care management. The ring fills with the total used against the total allowance;
 * only when that total is over does the rest run on as a second amber ring (TAV-3482). With no care management
 * allowance or use: an empty ring and N/A, as on the tracker.
 */
export const CompanyCareManagementOverview: React.FC<ComponentProps> = ({ view, status = READY_WIDGET }) => (
  <DonutFiguresCard
    title={copy.title}
    description={copy.description}
    titleAddon={<SectionInfo id="dashboard-cm-overview-section" label={copy.title} content={copy.section} />}
    className="company-care-management-overview"
    over={view?.over}
    dataCy="dashboard-care-management-overview"
    donut={view?.donut}
    legend={view?.legend}
    pending={
      status.phase !== 'ready' || !view ? (
        <DashboardWidgetState status={status} title={copy.title} dataCy="dashboard-care-management-overview" />
      ) : undefined
    }
    emptyLabel={copy.empty}
    emptyDataCy="dashboard-care-management-overview-empty"
  />
);
